"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerCssClassname = void 0;
const playerCssClassname = (override) => {
    return override !== null && override !== void 0 ? override : '__remotion-player';
};
exports.playerCssClassname = playerCssClassname;
